module.exports = __webpack_public_path__ + "static/img/icon_tips.64ae7411.png";